import styled from "styled-components";
import {InnerLink} from "../../../styles/business-components";

export const Footer = styled.footer`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 400px;

  font-size: 14px;
  background: ${({ theme }) => theme.business.colors.footerBackground};
  color: ${({theme}) => theme.business.colors.textColor};

  @media only screen and (${({theme}) => theme.media.small}) {
    height: 400px;
  }
  
  @media only screen and (${({theme}) => theme.media.medium}) {
    padding: 1rem 5%;
    height: 400px;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    height: 150px;
  }
  
  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 1rem 100px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 1rem 200px;
  }
`

export const Container = styled.div`
  display: none;

  @media only screen and (${({theme}) => theme.media.large}) {
    display: block;
  }
`

export const SmallContainer = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;

  @media only screen and (${({theme}) => theme.media.medium}) {
    padding-bottom: 5vh;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    display: none;
  }
`

export const Brand = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0;
  color: ${({theme}) => theme.business.colors.textColor};
`

export const BrandDesc = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  color: ${({theme}) => theme.business.colors.textColor};
`

export const Link = styled(InnerLink)`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
`

export const Social = styled.div`
  float: none;
  opacity: 0.6;

  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    float: none;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    float: none;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    float: right;
  }
  
  & svg {
    margin: 0 0 0 5px;
    :hover {
      color: black;
    }
  }
`

export const SocialLink = styled(Link)`
  & svg path {
    fill: ${({theme}) => theme.business.colors.textColor};
  }
  &:hover svg path {
    fill: ${({theme}) => theme.colors.footerSocialLinkHover};
  }
`

export const CopyRights = styled.div`
  float: right;
  opacity: 0.6;
  color: ${({theme}) => theme.business.colors.textColor};
`

export const Links = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 50%;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    width: 40%;
  }
`

export const Line = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`